import React from 'react'
import {Card, CardHeader, CardBody,Box,Text,Spinner,Tip,NameValuePair } from 'grommet';
import {User,Phone,MailOption,Organization,Location, ContactInfo, Calendar, Clock,Alert} from 'grommet-icons';
import moment from 'moment'

export function CollectionDetailsCard(props) {  
  return (
    <Tip plain content={<Box direction='row' elevation='large' margin='medium' pad="small" gap="small" width={{ max: 'large' }} round background="white"><Alert color='status-warning' /><Text margin={{top:'xxsmall'}} weight='bold' size='small'>Please ensure the shipment is ready for collection on the requested date. Failed collection attempts may be charged.</Text></Box>}>
      <Card margin={'small'} round pad='xsmall' background='background-front' elevation='large' style={{minWidth:260}}>
      <CardHeader  margin='small'>
          <Box direction='row'><Text weight='bold' size='medium' style={{marginLeft:7}}>Collection Details</Text></Box>
      </CardHeader>
      <CardBody>
        <Box direction='row' margin='small'>
        <NameValuePair name={<Box direction='row'><Calendar color='brand' /></Box>} icon={<Calendar />}>
          <Text weight={'bold'} margin={{left:'small', top:'xxsmall'}} size='small' >{moment(props.collection.collectionDate).format("dddd DD MMMM YYYY")}</Text>
        </NameValuePair>
          </Box>
        <Box direction='row' margin='small'>
        <NameValuePair name={<Box direction='row'><Clock color='brand' /></Box>} icon={<Clock />}>
            <Text weight={'bold'}  margin={{left:'small', top:'xxsmall'}} size='small' >{props.collection.collectionTime} - {props.collection.pickupCloseTime}</Text>
        </NameValuePair>
          </Box>            
      </CardBody>
      </Card>
    </Tip>
  )
}

export function ContactDetailsCard(props) {
    let view;
    if (props.load){
        view = <CardBody><Spinner /></CardBody>
    } else {
        view = (
            <CardBody margin='small'>
              <Box direction='row' margin='small'><Organization color='brand' margin='xsmall' /><Text margin='xsmall' size='xsmall' >{props.contact.contact.companyName}</Text></Box>
              <Box direction='row' margin='small'><User color='brand' margin='xsmall' /><Text margin='xsmall' size='xsmall' >{props.contact.contact.contactName}</Text></Box>
              <Box direction='row' margin='small'><Phone color='brand' margin='xsmall' /><Text margin='xsmall' size='xsmall' >{props.contact.contact.contactPhone}</Text></Box>
              <Box direction='row' margin='small'><MailOption color='brand' margin='xsmall' /><Text margin='xsmall' size='xsmall' >{props.contact.contact.contactEmail}</Text></Box>
              <Box direction='row' margin='small'><Location color='brand' margin='xsmall' /><Text margin='xsmall' size='xsmall' >{props.contact.city}, {props.contact.country.CountryName}</Text></Box>
              </CardBody>
        )
    }
    return (        
        <Box margin='small'>
              <Card  pad='small' background='background-front' elevation='large' width='medium' round>
              <CardHeader  margin='small'>
                  <Box direction='row'><ContactInfo color='brand' margin='small' /><Text weight='bold' style={{marginLeft:7}}>Sender Contact Details</Text></Box>
              </CardHeader>
                {view}
              </Card>
      </Box>
    )
  }
